// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1--hL","list":"styles_list__2BiCY"};